module.exports = __webpack_public_path__ + "assets/img/cider-color.c99b912c.svg";